<template>
  <div class="projects-shell">
    <div class="projects-scroll">
      <div class="gallery-container">
        <div
          v-for="project in projects"
          :key="project.name"
          class="project-card"
          @click="openModal(project)"
        >
          <img class="project-img" :src="project.img" :alt="project.name" />
          <div class="project-overlay">
            <div class="name">{{ project.name }}</div>
            <div class="description">{{ project.description }}</div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="selectedProject" class="modal-backdrop" @click.self="closeModal">
      <div class="modal-panel">
        <div class="modal-frame-top"></div>
        <button class="modal-close-x" @click="closeModal" aria-label="Close modal">×</button>

        <div class="modal-hero">
          <img
            class="modal-img"
            :src="selectedProject.img"
            :alt="selectedProject.name"
          />
          <div class="modal-hero-glow"></div>
        </div>

        <div class="modal-body">
          <span class="modal-stack">{{ selectedMeta.stack }}</span>
          <h2 class="modal-title">{{ selectedProject.name }}</h2>
          <p class="modal-description">{{ selectedMeta.blurb }}</p>

          <div class="modal-actions">
            <button class="visit-btn" @click="goToProject(selectedProject.link)">
              Launch
            </button>
            <button class="close-btn" @click="closeModal">Dismiss</button>
          </div>
        </div>

        <div class="modal-frame-bottom"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      projects: [
        {
          name: 'Ministerio de Desarrollo Social - SDE',
          description:
            'WORDPRESS | Government website for the Social Development Ministry of Santiago del Estero.',
          link: 'http://www.mdssde.gob.ar/',
          img: '/resources/mds.png',
        },
        {
          name: 'Puestify',
          description:
            'VUE + EXPRESS | Cloud e-commerce platform that connects users with local businesses, product listings, and online sales.',
          link: 'https://puestify.com',
          img: '/resources/puestito-online.png',
        },
        {
          name: 'Puestify Turnos',
          description:
            'VUE + EXPRESS | Appointment and booking system for businesses, built on the Puestify platform.',
          link: 'https://turnos.puestify.com',
          img: 'https://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/svg/1f4c5.svg',
        },
        {
          name: 'SN-MDS',
          description:
            'VUE + EXPRESS | Notification system for the Social Development Ministry of Santiago del Estero.',
          link: 'https://sn-mds.nazadoto.com',
          img: '/resources/sn-mds.png',
        },
        {
          name: 'SGTS',
          description:
            'VUE + EXPRESS | Tarjetas Sociales management system for the Social Development Ministry of Santiago del Estero.',
          link: 'https://sgts.nazadoto.com',
          img: '/resources/sgts.png',
        },
        {
          name: 'Olgadle',
          description:
            'VUE + EXPRESS | Wordle-like webapp for the streaming channel "OLGA".',
          link: 'https://olgadle.nazadoto.com',
          img: '/resources/olgadle.png',
        },
        {
          name: 'DND',
          description:
            'VUE + EXPRESS | A platform where players can store and manage their character sheets, notes, and stats, while tracking campaign progress together with their DM.',
          link: 'https://dnd.nazadoto.com',
          img: 'https://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/svg/2694.svg',
        },
      ],
      selectedProject: null,
    };
  },
  computed: {
    selectedMeta() {
      if (!this.selectedProject) {
        return { stack: '', blurb: '' };
      }
      const parts = this.selectedProject.description.split('|');
      if (parts.length > 1) {
        return {
          stack: parts[0].trim(),
          blurb: parts.slice(1).join('|').trim(),
        };
      }
      return {
        stack: 'PROJECT',
        blurb: this.selectedProject.description,
      };
    },
  },
  methods: {
    openModal(project) {
      this.selectedProject = project;
    },
    closeModal() {
      this.selectedProject = null;
    },
    goToProject(link) {
      window.open(link, '_blank');
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap');

.name {
  font-size: 0.72rem;
  font-weight: bold;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 25px rgba(0, 0, 0, 0.8);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.projects-shell {
  width: 100%;
  height: calc(100svh - 60px);
  max-height: calc(100svh - 60px);
  margin: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-sizing: border-box;
}

.projects-scroll {
  flex: 1;
  min-height: 0;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 24px 16px;
  box-sizing: border-box;
}

.gallery-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 160px));
  width: 100%;
  max-width: 720px;
  margin: 0 auto;
  gap: 12px;
  justify-content: center;
  box-sizing: border-box;
}

.description {
  font-size: 0.7rem;
  line-height: 1.2;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.project-card {
  position: relative;
  width: 100%;
  max-width: 160px;
  aspect-ratio: 4 / 3;
  min-height: 0;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.4);
  border-radius: 6px;
  justify-self: center;
}

.project-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 18px rgba(0, 0, 0, 0.45);
  z-index: 2;
}

.project-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.project-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(
    to top,
    rgb(10, 10, 10),
    rgba(10, 10, 10, 0.7),
    rgba(10, 10, 10, 0.5),
    transparent
  );
  color: white;
  padding: 8px;
  text-align: left;
  max-height: 70%;
  overflow: hidden;
}

/* --- Modal (Dota HUD style) --- */
.modal-backdrop {
  position: fixed;
  inset: 0;
  background:
    radial-gradient(ellipse at center, rgba(40, 28, 18, 0.35), transparent 55%),
    rgba(8, 8, 10, 0.88);
  display: grid;
  place-items: center;
  margin: 0;
  padding: 16px;
  z-index: 1100;
}

.modal-panel {
  position: relative;
  width: min(540px, 100%);
  max-height: calc(100svh - 32px);
  display: flex;
  flex-direction: column;
  background:
    linear-gradient(165deg, rgba(55, 55, 58, 0.98) 0%, rgba(28, 28, 30, 0.98) 45%, rgba(18, 18, 20, 0.99) 100%);
  clip-path: polygon(0 0, 100% 0, 100% calc(100% - 14px), calc(100% - 14px) 100%, 0 100%);
  box-shadow:
    0 22px 48px rgba(0, 0, 0, 0.7),
    inset 0 1px 0 rgba(255, 255, 255, 0.08),
    inset 0 -2px 8px rgba(0, 0, 0, 0.35);
  color: white;
  animation: modalIn 0.22s ease;
  overflow: hidden;
}

.modal-frame-top {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(
    to right,
    rgba(255, 94, 0, 0.85),
    rgba(255, 196, 0, 0.35),
    transparent 70%
  );
  z-index: 2;
}

.modal-frame-bottom {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(
    to right,
    transparent,
    rgba(100, 224, 255, 0.25),
    transparent
  );
}

.modal-hero {
  position: relative;
  margin: 14px 14px 0;
  overflow: hidden;
  clip-path: polygon(0 0, 100% 0, 100% 88%, 96% 100%, 0 100%);
  background: #111;
  border: 1px solid rgba(255, 255, 255, 0.12);
  box-shadow: inset 0 0 40px rgba(0, 0, 0, 0.55);
}

.modal-img {
  display: block;
  width: 100%;
  height: 210px;
  object-fit: cover;
  object-position: center top;
}

.modal-hero-glow {
  pointer-events: none;
  position: absolute;
  inset: auto 0 0 0;
  height: 55%;
  background: linear-gradient(
    to top,
    rgba(12, 12, 14, 0.95),
    rgba(12, 12, 14, 0.35),
    transparent
  );
}

.modal-body {
  padding: 14px 18px 20px;
  overflow-y: auto;
  min-height: 0;
}

.modal-stack {
  display: inline-block;
  margin-bottom: 8px;
  padding: 3px 10px 2px;
  font-family: 'Bebas Neue', sans-serif;
  font-size: 0.95rem;
  letter-spacing: 1.5px;
  color: #ffb347;
  background: linear-gradient(to right, rgba(255, 94, 0, 0.18), transparent);
  border-left: 2px solid rgba(255, 94, 0, 0.85);
  text-shadow: 0 0 12px rgba(255, 120, 0, 0.35);
}

.modal-title {
  margin: 0 0 10px;
  font-family: 'Bebas Neue', sans-serif;
  font-size: 1.85rem;
  letter-spacing: 1px;
  line-height: 1.05;
  font-weight: 400;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.55);
}

.modal-description {
  margin: 0 0 18px;
  font-size: 0.95rem;
  line-height: 1.45;
  color: rgba(230, 230, 235, 0.9);
}

.modal-actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
}

.visit-btn,
.close-btn {
  position: relative;
  min-width: 110px;
  padding: 10px 18px;
  border: none;
  cursor: pointer;
  font-family: 'Bebas Neue', sans-serif;
  font-size: 1.05rem;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: white;
  clip-path: polygon(8% 0, 100% 0, 92% 100%, 0 100%);
  transition: filter 0.15s ease, transform 0.15s ease;
}

.visit-btn {
  background: linear-gradient(to bottom, #c45a18, #7a2f0a);
  box-shadow:
    0 4px 12px rgba(0, 0, 0, 0.4),
    inset 0 1px 0 rgba(255, 200, 120, 0.25);
}

.close-btn {
  background: linear-gradient(to bottom, #3a3a3e, #222226);
  box-shadow:
    0 4px 12px rgba(0, 0, 0, 0.35),
    inset 0 1px 0 rgba(255, 255, 255, 0.08);
  color: #c8c8cc;
}

.visit-btn:hover,
.close-btn:hover {
  filter: brightness(1.12);
  transform: translateY(-1px);
}

.modal-close-x {
  position: absolute;
  top: 10px;
  right: 12px;
  z-index: 3;
  width: 32px;
  height: 32px;
  border: 1px solid rgba(255, 255, 255, 0.25);
  background: rgba(0, 0, 0, 0.55);
  color: #ddd;
  cursor: pointer;
  font-size: 1.25rem;
  line-height: 1;
  clip-path: polygon(20% 0, 100% 0, 80% 100%, 0 100%);
  transition: background 0.15s ease, color 0.15s ease;
}

.modal-close-x:hover {
  background: rgba(255, 72, 0, 0.45);
  color: white;
}

@keyframes modalIn {
  from {
    opacity: 0;
    transform: translateY(10px) scale(0.97);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@media (max-width: 850px) {
  .projects-shell {
    height: calc(100svh - 60px);
    max-height: calc(100svh - 60px);
  }
  .projects-scroll {
    padding: 12px;
  }
  .gallery-container {
    grid-template-columns: repeat(auto-fit, minmax(120px, 140px));
    max-width: 100%;
  }
  .project-card {
    max-width: 140px;
  }
  .modal-img {
    height: 180px;
  }
}

@media (max-width: 550px) {
  .gallery-container {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
  }
  .project-card {
    max-width: none;
  }
  .name {
    font-size: 0.78rem;
  }
  .description {
    font-size: 0.68rem;
  }
  .modal-body {
    padding: 12px 14px 16px;
  }
  .modal-title {
    font-size: 1.45rem;
  }
  .modal-description {
    font-size: 0.86rem;
  }
  .modal-actions {
    justify-content: stretch;
  }
  .visit-btn,
  .close-btn {
    flex: 1;
    min-width: 0;
    padding: 10px 12px;
    font-size: 0.95rem;
  }
}
</style>
